export const styles = {
  tablePagination: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
  },
};
